import { useEffect, useRef } from "react";

/**
 * On each time given value changes it returns the previous value of the given variable/constant.
 */
export default function usePrevValue<TValue>(value: TValue): TValue | undefined {
  const prevValue = useRef<TValue>(value);
  const currentValue = useRef<TValue>(value);

  useEffect(() => {
    prevValue.current = currentValue.current;
    currentValue.current = value;
  }, [value]);

  return prevValue.current;
}
